import {createApp, reactive} from 'vue'
import App from './App.vue'
// import "bootstrap/dist/css/bootstrap.min.css"
//import "@/assets/css/front.min.css";
import router from '@/GenerationRouter';
import {createPinia} from "pinia";
import funcPlugins from '@/plugins/func';
import commonJs from "@/plugins/commonJs";
import globalComponents from '@/plugins/global-components';
//import globalDirectives from '@/plugins/global-directives';
import dayjs from '@/plugins/dayjs';
import menujs from '@/plugins/menu';
// 데이터피커(캘린더)
import { setupCalendar } from 'v-calendar'
import VueSignaturePad from 'vue-signature-pad';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import VueCookies from 'vue-cookies';


let app = createApp(App);

app.use(router.instance);
app.use(globalComponents);
//app.use(globalDirectives);
app.use(dayjs);
app.use(menujs);
app.use(createPinia().use(piniaPluginPersistedstate));
app.use(funcPlugins);
app.use(commonJs);
// 데이터피커(캘린더)
app.use(setupCalendar, {})
app.use(VueSignaturePad);
app.use(VueCookies);
app.config.errorHandler = (err, vm, info) => {

};

app.mount('#app');